import React from "react";
import ReactImageGallery from "../components-react/gallery/ReactImageGallery";
import "react-image-gallery/styles/css/image-gallery.css";

const TransformationImages = ({ from, rowData }) => {
  return (
    <div className="image-gallery-container mt30">
      <ReactImageGallery
        imagesArray={
          from === "blog" ? rowData?.article_images : rowData?.prog_pics
        }
      />
    </div>
  );
};

export default TransformationImages;
